import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function ScopedAdviceCard({ answer }: Props) {
  const isFallback = answer.fallback === true;
  return (
    <article
      className={`rounded-lg border p-4 text-sm ${
        isFallback
          ? 'border-rose-200 bg-rose-50 text-rose-900'
          : 'border-emerald-200 bg-emerald-50 text-emerald-900'
      }`}
    >
      <div className="mb-2 flex items-center gap-2">
        <span
          className={`rounded px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${
            isFallback ? 'bg-rose-200' : 'bg-emerald-200'
          }`}
        >
          {isFallback ? 'Advice (fallback)' : 'Scoped advice'}
        </span>
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
    </article>
  );
}
